import React from 'react';
import { Link } from 'react-router-dom';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

const WorkWithUsCTA = () => {
  return (
    <div className="home4-contact-area">
      <div className="container">
        <div className="row">
          <Reveal className="col-lg-12" delay={0.08}>
            <div className="contact-wrapper text-center magnetic-item">
              <h2 className="title">
                <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                  Work With Us
                </GradientText>
              </h2>
              <h2 className="content">
                <ShinyText
                  text="Let’s Talk"
                  className="nalexus-heading-shine"
                  color="#f1ede3"
                  shineColor="#ffd369"
                  speed={2.6}
                />
              </h2>
              <div className="contact-btn">
                <Link className="magnetic-item nalexus-cta" to="/contact">
                  Contact With Us.
                  <svg width="32" height="32" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 1H12M12 1V13M12 1L0.5 12" />
                  </svg>
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default WorkWithUsCTA;





